import ViewMembersPage from "components/viewMembers/ViewMembers.component"

const ViewMembers = () => {
  return (
    <ViewMembersPage />
  )
}

export default ViewMembers
